import Vue from "vue";
import VueRouter from "vue-router";
// import store from "../store";
import SettingsRoutes from "./3pl/settings/index";
import OperationRoutes from "./3pl/operations";
import usersRoutes from "./3pl/users";
import IncidentAndRequest from "./3pl/incidentAndRequest";
import BillingsAndPayment from "./3pl/billingsAndPayment";
import CrmRoutes from "./3pl/crm";
import billingandcollection from "./3pl/billingandcollection";
// import OndemandRoutes from "./Ondemand/Settings/index";
import OndemandRoutes from "./Ondemand/index";
import Rating from "./Ondemand/rating";
import Accounting from "./3pl/accounting";
import EnterpriseCustomerRoutes from "./EnterpriseCustomer/index";


Vue.use(VueRouter);

const routes = [
  {
    path: "/404",
    name: "PageNotFound",
    component: () => import("@/views/PageNotFound"),
  },
  { path: "*", redirect: "/404" },
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    redirect: "/",
    component: () => import("@/views/Signup/index.vue"),
  },
  {
    path: "/signup/verify",
    name: "Signup_verify",
    component: () => import("@/views/Signup/Verify.vue"),
  },
  {
    path: "/signup/authentication",
    name: "SignupAuthentication",
    component: () => import("@/views/Signup/SignupAuthentication.vue"),
  },
  {
    path: "/login",
    name: "Login",
    redirect: "/",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/login/verify-otp",
    name: "VerifyOtp",
    component: () => import("@/components/Auth/Home/VerifyOTP"),
  },
  {
    path: "/login/security-question",
    name: "VerifySecurityQuestion",
    component: () => import("@/components/Auth/Home/VerifySecurityQuestion"),
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: () => import("@/views/Onboarding/index.vue"),
  },
  {
    path: "/onboarding/complete",
    name: "OnboardingComplete",
    component: () => import("@/views/Onboarding/OnboardingComplete.vue"),
  },
  {
    path: "/onboarding/verify_account",
    name: "VerifyAccount",
    component: () => import("@/views/Onboarding/VerifyAccount.vue"),
  },
  {
    path: "/onboarding/use-case",
    name: "OnboardingUseCase",
    component: () => import("@/views/Onboarding/UseCase/index.vue"),
  },
  {
    path: "/onboarding/account-type",
    name: "OnboardingAccountType",
    component: () => import("@/views/Onboarding/AccountType/index.vue"),
  },
  {
    path: "/onboarding/organization-information",
    name: "OnboardingOrganizationInformation",
    component: () =>
      import("@/views/Onboarding/OrganizationInformation/index.vue"),
  },
  {
    path: "/onboarding/account-owner",
    name: "OnboardingAccountOwner",
    component: () => import("@/views/Onboarding/AccountOwner/index.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/Password/ForgotPassword.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/Password/ResetPassword.vue"),
  },
  {
    path: "/",
    component: () => import("@/layouts/DashboardLayout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/user",
        name: "Users",
        component: () => import("@/views/3pl/User"),
      },
      {
        path: "/locations",
        name: "Locations",
        component: () => import("@/views/3pl/Locations"),
      },
      {
        path: "/fleets",
        name: "Fleets",
        component: () => import("@/views/3pl/Fleets/index"),
      },
    ],
  },
  {
    path: "/",
    meta: {
      requiresAuth: true,
    },
    component: () => import("@/layouts/NewLayout/DashboardLayout.vue"),
    children: [
      ...OperationRoutes,
      ...SettingsRoutes,
      ...CrmRoutes,
      ...usersRoutes,
      ...OndemandRoutes,
      ...IncidentAndRequest,
      ...BillingsAndPayment,
      ...billingandcollection,
      ...Rating,
      ...Accounting,
      ...EnterpriseCustomerRoutes,
      {
        path: "/settings/security-policy",
        name: "SecurityPolicy",
        component: () => import("@/views/3pl/Settings/SecurityPolicy/index"),
      },
      {
        path: "/bookings/booking_flow_new",
        name: "BookingFlowNew",
        component: () => import("@/views/bookings/BookingFlow"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("token")) {
      next({
        path: "/",
        // query: { redirectFrom: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 */

//  const originalPush = router.push;
//  router.push = function push(location, onResolve, onReject) {
//      if (onResolve || onReject) {
//          return originalPush.call(this, location, onResolve, onReject);
//      }
//      return originalPush.call(this, location).catch((err) => {
//          let reg = new RegExp('^Redirected when going from "[a-z_.\\/]+" to "[a-z_.\\/]+" via a navigation guard.$');
//          if (reg.test(err.message)) {
//              // If pushing interrupted because of redirection from navigation guard - ignore it.
//              return Promise.resolve(false);
//          }
//          // Otherwise throw error
//          return Promise.reject(err);
//      });
//  };
export default router;
